import React, { InputHTMLAttributes } from 'react';
import './InputField.css';

export interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  tooltip?: string;
  error?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  tooltip,
  error,
  id,
  className = '',
  ...props
}) => {
  return (
    <div className="form-group">
      {label && (
        <label htmlFor={id}>
          {label}
          {tooltip && (
            <div className="tooltip">
              <span>?</span>
              <span className="tooltiptext">{tooltip}</span>
            </div>
          )}
        </label>
      )}
      
      <input 
        id={id}
        className={`input-field ${error ? 'error' : ''} ${className}`}
        {...props}
      />
      
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default InputField; 